'use client';

import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_aboDf1fcF',
      userPoolClientId: '17q23ih33qptm6unthg0jjghkl',
      userPoolEndpoint: 'https://cognito-idp.us-east-2.amazonaws.com',
      loginWith: {
        email: true,
      },
    },
  },
});

export default function AmplifyProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}